import * as React from 'react';
import { withTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps } from 'react-router-dom';
import './viewfileContainer.scss';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Button, Card, CardBody, CardHeader, Flex, Header, Text } from '@fluentui/react-northstar';
import { connect } from 'react-redux';
import { TFunction } from "i18next";
import { getBaseUrl } from '../../configVariables';
import { Document, Page, pdfjs } from "react-pdf";
import { getViewFile, postViewFile, getFileType } from '../../apis/messageListApi';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`


export interface IViewFileProps extends RouteComponentProps, WithTranslation {
    getDraftMessagesList?: any;
    getMessagesList?: any;
    selectedStation?: any;


}

export interface IViewtabsContainerState {
    url: string;
    file: string,
    numPages: number,
    pageNumber: number
    showSign: boolean,
    documentTitle: string,
    publishedBy: string,
    publishedOn: string,
    canBeSigned: boolean,
    user: string,
    notifcation: string,
    isPdf: boolean,

}

class ViewFileContainer extends React.Component<IViewFileProps, IViewtabsContainerState> {

    readonly localize: TFunction;
    constructor(props: IViewFileProps) {
        super(props);
        this.localize = this.props.t;

        this.state = {
            file: '',
            url: getBaseUrl() + "/newmessage?locale={locale}",
            numPages: 0,
            pageNumber: 1,
            showSign: false,
            publishedBy: '',
            publishedOn: '',
            documentTitle: '',
            canBeSigned: false,
            user: '',
            notifcation: '',
            isPdf: true,
        }

    }

    private signDocument = () => {
        postViewFile(this.state.user, this.state.notifcation).then(x => window.close())
    }

    private getData = async (id: string, user: string) => {
        let response = await getViewFile(id, user)
        
        return response.data;
    }

    public componentDidMount() {

        const params = this.props.match.params;


        this.setState({ user: params['user'], notifcation: params['id'] });



        this.getData(params['id'], params['user']).then(x => {
            this.setState({ documentTitle: x.title, file: x.file, publishedBy: x.publishedBy, publishedOn: x.publishedOn, canBeSigned: x.canBeSigned })


        })





    }
    onFileChange = (event) => {
        this.setState({
            file: event.target.files[0]
        });
    }

    private onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }
    private nextPage = () => {
        const currentPageNumber = this.state.pageNumber;
        let nextPageNumber;
        if (currentPageNumber + 1 > this.state.numPages) {
            nextPageNumber = 1;
        } else {
            nextPageNumber = currentPageNumber + 1;
        }

        if (nextPageNumber === this.state.numPages) {
            this.setState({
                showSign: true
            });
        }
        this.setState({
            pageNumber: nextPageNumber
        });
    }

    private prevPage = () => {
        const currentPageNumber = this.state.pageNumber;
        let nextPageNumber;
        if (currentPageNumber - 1 < 1) {
            nextPageNumber = 1;
        } else {
            nextPageNumber = currentPageNumber - 1;
        }
        this.setState({
            pageNumber: nextPageNumber
        });
    }

    private pdfError = () => {
        this.setState({
            isPdf: false
        });
    }

    private getWidth = () => {


        const width = window.innerWidth;
        return  width > 1000 ? 1000 : width;
    }


    public render(): JSX.Element {

        return (
            <Flex column fill hAlign="center" gap="gap.small">
                <Flex column hAlign="center" gap="gap.small">

                    <Header color="brand" align="center" content={this.state.documentTitle} />
                    <Text color="grey" align="center" content={`Issued By: ${this.state.publishedBy} | ${this.state.publishedOn}`} size="small" weight="semibold" />

                </Flex>
                <Flex hAlign="center">
                    {this.state.file && this.state.isPdf ?

                        <Document file={this.state.file} onLoadSuccess={this.onDocumentLoadSuccess} onLoadError={this.pdfError}  >
                            <Page pageNumber={this.state.pageNumber} width={this.getWidth()} scale={1} >

                            </Page>
                        </Document> : <img src={this.state.file} alt={this.state.documentTitle} />}

                </Flex>

                {this.state.isPdf ?
                    <Flex vAlign="center" gap="gap.small" padding="padding.medium">

                        <Button content="Next" loader="Program card" onClick={this.nextPage} />
                        <Text color="brand" size="larger" weight="bold">{this.state.pageNumber}/{this.state.numPages}</Text>
                        <Button content="Prev" loader="Program card" onClick={this.prevPage} />

                    </Flex> : ''}
                {this.state.showSign || !this.state.isPdf ?

                    <Flex hAlign="center">
                        <Card elevated fluid size="largest">
                            <CardHeader>
                                <Flex gap="gap.medium">
                                    <Flex column>
                                        <Text content="Sign Document" align="center" size="larger" weight="bold" />
                                        <Text content="I acknowledge that I have read and understand the above document" align="center" size="small" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Button content="Sign Document" loader="Program card" size="larger" onClick={this.signDocument} primary fluid />
                            </CardBody>
                        </Card> </Flex> : ''}
            </Flex>

        )
    }
}

const mapStateToProps = (state: any) => {
    return {};
}

const viewFileContainerWithTranslation = withTranslation()(ViewFileContainer);
export default connect(mapStateToProps, {})(viewFileContainerWithTranslation);